import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetTipoTramiteActividadTipos } from '../../shared/interfaces/database/configuracion';

@Injectable({
  providedIn: 'root'
})
export class TipoTramiteActividadTiposService {
  private readonly baseUrl = `${environment.apiUrl}/api/tipo-tramite-actividad-tipos`;

  constructor(private readonly http: HttpClient) { }

  getTipoTramiteActividadTipos(): Observable<IGetTipoTramiteActividadTipos[]> {
    return this.http.get<IGetTipoTramiteActividadTipos[]>(`${this.baseUrl}`);
  }
}